import { useMemo } from 'react';
import type { ScreenType } from '../constants';
import { useIsScreen } from './use-is-screen';

export type ScreenConfigType<ConfigItemType> = Partial<Record<ScreenType, ConfigItemType>> & {
  placeholder: ConfigItemType;
};
/**
 * 根据当前屏幕尺寸返回对应的配置
 * @param config 自定义配置，可选
 * @returns 当前屏幕对应的配置
 */
export const useScreenConfig = <ConfigItemType>(config: ScreenConfigType<ConfigItemType>): ConfigItemType => {
  const { matchList } = useIsScreen();
  // 根据屏幕状态返回对应的配置
  return useMemo(() => {
    if (matchList.length > 0) {
      for (const type of matchList) {
        const t = config[type];
        if (t) {
          return t;
        }
      }
    }
    return config.placeholder;
  }, [matchList, config]);
};
